<template>
  <div>
    <loader v-if="!pageLoaded"></loader>

    <div v-else class="px-4 mt-2">
      <v-navigation-drawer
        v-model="drawer"
        app
        right
      >
        <v-list dense class="px-3 mb-6">
          <v-subheader class="ml-2">
            <span class="text-uppercase">Filter Laureates</span>
          </v-subheader>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Type</v-list-item-title>
              <v-list-item-subtitle>
                <v-checkbox v-model="typeFilter" class="ml-2" value="Person" label="Person"></v-checkbox>
                <v-checkbox v-model="typeFilter" class="ml-2 mt-n2" value="Organization" label="Organization"></v-checkbox>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-autocomplete
              v-model="countriesFilter"
              :items="countries"
              item-text="name"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Country of Work"
              multiple
              dense
              filled
              clearable
            ></v-autocomplete>
          </v-list-item>

          <v-list-item>
            <v-autocomplete
              v-model="nationalitiesFilter"
              :items="countries"
              item-text="nationality"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Nationality"
              multiple
              dense
              filled
              clearable
            ></v-autocomplete>
          </v-list-item>

          <v-list-item>
            <v-autocomplete
              v-model="professionsFilter"
              :items="professions"
              item-text="name"
              item-value="id"
              :menu-props="{ maxHeight: '400' }"
              label="Profession"
              multiple
              dense
              filled
              clearable
            ></v-autocomplete>
          </v-list-item>

          <v-list-item>
            <v-autocomplete
              v-model="genderFilter"
              :items="genders"
              :menu-props="{ maxHeight: '400' }"
              label="Gender"
              multiple
              dense
              filled
              clearable
            ></v-autocomplete>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Date of Birth</v-list-item-title>
              <v-list-item-subtitle>
                <v-select
                  v-model="dateOfBirthFrom"
                  :items="years"
                  :menu-props="{ maxHeight: '400' }"
                  class="mt-4"
                  label="Date From"
                  prepend-icon="mdi-calendar"
                  dense
                  clearable
                ></v-select>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-select
                  v-model="dateOfBirthTo"
                  :items="years"
                  :menu-props="{ maxHeight: '400' }"
                  class="mt-4"
                  label="Date To"
                  prepend-icon="mdi-calendar"
                  dense
                  clearable
                ></v-select>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Deceased</v-list-item-title>
              <v-list-item-subtitle>
                <v-checkbox v-model="ceasedToExistYes" class="ml-2" label="Yes"></v-checkbox>
                <v-checkbox v-model="ceasedToExistNo" class="ml-2 mt-n2" label="No"></v-checkbox>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item three-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Date of Death</v-list-item-title>
              <v-list-item-subtitle>
                <v-select
                  v-model="dateOfDeathFrom"
                  :items="years"
                  :menu-props="{ maxHeight: '400' }"
                  class="mt-4"
                  label="Date From"
                  prepend-icon="mdi-calendar"
                  dense
                  clearable
                ></v-select>
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                <v-select
                  v-model="dateOfDeathTo"
                  :items="years"
                  :menu-props="{ maxHeight: '400' }"
                  class="mt-4"
                  label="Date To"
                  prepend-icon="mdi-calendar"
                  dense
                  clearable
                ></v-select>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider></v-divider>

          <v-list-item two-line>
            <v-list-item-content>
              <v-list-item-title class="mt-2">Top 100</v-list-item-title>
              <v-list-item-subtitle>
                <v-checkbox v-model="top100Filter" class="ml-2" value="Yes" label="Yes"></v-checkbox>
                <v-checkbox v-model="top100Filter" class="ml-2 mt-n2" value="No" label="No"></v-checkbox>
                <v-checkbox v-model="top100Filter" class="ml-2 mt-n2" value="Maybe" label="Maybe"></v-checkbox>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-btn
                @click="refreshFilters()"
                outlined
                color="accent"
              >
                <v-icon left>mdi-autorenew</v-icon>
                Refresh
              </v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-navigation-drawer>

      <v-container class="mb-4">
        <v-row>
          <v-card class="width-100">
            <v-toolbar flat class="indigo lighten-5">
              <v-text-field
                solo
                flat
                dense
                label="Search"
                style="max-width: 280px"
                hide-details
                v-model="search"
                :class="[search && !filteredLaureates.length ? 'search-no-results' : 'search']"
              >
                <template v-slot:prepend-inner>
                  <v-icon>mdi-magnify</v-icon>
                </template>
                <template v-slot:append v-if="search">
                  <v-btn small icon class="mr-n1" @click="search = ''">
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-text-field>

              <v-spacer></v-spacer>

              <span class="caption mx-1 hidden-sm-and-down">Rows per page</span>
              <div style="max-width: 60px" class="mx-3">
                <v-select
                  v-model="pageSize"
                  :items="[20, 50, 100]"
                  dense
                  hide-details
                ></v-select>
              </div>

              <v-btn
                @click.stop="drawer = !drawer"
                icon
              >
                <v-icon class="text-subtitle">mdi-filter-outline</v-icon>
              </v-btn>
            </v-toolbar>

            <v-simple-table>
              <template v-slot:default>
                <thead v-if="filteredLaureates.length">
                  <tr class="indigo-lighten-6">
                    <th></th>
                    <th
                      @click="sortByFullName()"
                      class="th-clickable"
                    >Name</th>
                    <th
                      @click="sortBy('gender')"
                      class="th-clickable"
                    >Gender</th>
                    <th class="th-award-name">Award</th>
                    <th
                      @click="sortBy('type')"
                      class="th-clickable"
                    >Type</th>
                    <th
                      class="th-140"
                    >Country Of Work</th>
                    <th class="th-140">Profession</th>
                    <th
                      class="th-140"
                    >Nationality</th>
                    <th
                      @click="sortByDeceased()"
                      class="th-clickable"
                    >Deceased</th>
                    <th
                      @click="sortBy('date_of_birth')"
                      class="th-date th-clickable"
                    >Date of Birth</th>
                    <th
                      @click="sortBy('date_of_death')"
                      class="th-date th-clickable"
                    >Date of Death</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(item, $index) in paginatedLaureates"
                    :key="$index"
                    @click="goToLaureate(item.id)"
                    class="blue-grey--text text--darken-3 tr-laureate"
                  >
                    <td class="py-1 td-avatar">
                      <img
                        v-if="item.image"
                        :src="`${baseURL}/img/laureates/350/${item.image}`"
                      >
                      <v-avatar v-else color="blue-grey lighten-5">
                        <span class="blue-grey--text text--darken-1">
                          {{ item | fullName | capitalizeName }}
                        </span>
                      </v-avatar>
                    </td>
                    <td>
                      <span>{{ item | fullName }}</span>
                    </td>
                    <td>{{ item.gender }}</td>
                    <td>
                      <span v-if="item.awards.length === 1">{{ item.awards[0].name }}</span>
                      <li v-else v-for="(award, $index) in item.awards" :key="$index + item.id + '-' + award.id">
                        <span>{{ award.name }}</span>
                      </li>
                    </td>
                    <td>{{ item.type }}</td>
                    <td>
                      <span v-if="item.countries.length === 1">{{ item.countries[0].name }}</span>
                      <li v-else v-for="country in item.countries" :key="item.id + country.id">
                        <span>{{ country.name }}</span>
                      </li>
                    </td>
                    <td>
                      <span v-if="item.professions.length === 1">{{ item.professions[0].name }}</span>
                      <li v-else v-for="profession in item.professions" :key="item.id + profession.id">
                        <span>{{ profession.name }}</span>
                      </li>
                    </td>
                    <td>
                      <span v-if="item.nationalities.length === 1">{{ item.nationalities[0].name }}</span>
                      <li v-else v-for="nationality in item.nationalities" :key="item.id + nationality.id">
                        <span>{{ nationality.name }}</span>
                      </li>
                    </td>
                    <td>
                      <span v-if="item.date_of_death && item.type == 'Person'">Yes</span>
                      <span v-if="!item.date_of_death && item.type == 'Person'">No</span>
                    </td>
                    <td>
                      <span v-if="item.date_of_birth">{{ moment(item.date_of_birth).format('L') }}</span>
                    </td>
                    <td>
                      <span v-if="item.date_of_death">{{ moment(item.date_of_death).format('L') }}</span>
                    </td>
                    <td>
                      <v-btn
                        @click.stop="callConfirmLaureateDeleteDialog(item)"
                        icon
                      >
                        <v-icon class="text-subtitle">mdi-delete-outline</v-icon>
                      </v-btn>
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card>

          <div v-if="!filteredLaureates.length" class="mx-4 my-6 grey--text text--darken-1 text-center width-100">
            No matching <span class="font-weight-medium">Laureates</span> found in the database
          </div>
        </v-row>

        <v-row justify="center" v-if="filteredLaureates.length">
          <v-col cols="8">
            <v-container>
              <v-pagination
                v-model="pageNumber"
                :length="pagesQty"
              ></v-pagination>
            </v-container>
          </v-col>
        </v-row>
      </v-container>

      <v-btn
        link
        :to="{ name: 'laureates.create' }"
        dark
        fab
        bottom
        right
        fixed
        color="primary"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>

      <!-- Confirm Delete Laureate Dialog-->
      <confirm-delete-laureate-dialog
        ref="confirmLaureateDeleteDialog"
        :laureate="laureateToDelete"
      ></confirm-delete-laureate-dialog>

    </div>
  </div>
</template>

<script>
import ConfirmDeleteLaureateDialog from '@/components/laureates/ConfirmDeleteLaureateDialog.vue'
import Loader from '@/components/Loader'
import messagesMixin from '@/mixins/messagesMixin'

export default {
  name: 'Laureates',

  mixins: [messagesMixin],

  components: {
    ConfirmDeleteLaureateDialog,
    Loader
  },

  data () {
    return {
      ceasedToExistYes: false,
      ceasedToExistNo: false,
      countries: [],
      countriesFilter: [],
      dateOfBirthFrom: null,
      dateOfBirthTo: null,
      dateOfDeathFrom: null,
      dateOfDeathTo: null,
      drawer: false,
      genderFilter: [],
      genders: ['Unknown', 'Male', 'Female', 'Intersex', 'Organization'],
      laureates: [],
      laureateToDelete: {},
      nationalitiesFilter: [],
      pageLoaded: false,
      pageNumber: 1,
      pageSize: 20,
      professions: [],
      professionsFilter: [],
      search: '',
      sortByNameAsc: true,
      top100Filter: [],
      typeFilter: []
    }
  },

  mounted () {
    Promise.all([
      this.getCountries(),
      this.getLaureates(),
      this.getProfessions()
    ])
      .then(() => {
        this.pageLoaded = true
      })
  },

  computed: {
    filteredLaureates () {
      const search = this.search ? this.search.toLowerCase() : ''

      let laureates = this.laureates.filter(item => (item.first_name + ' ' + item.last_name).toLowerCase().includes(search))

      if (this.typeFilter.length) {
        laureates = laureates.filter(item => this.typeFilter.includes(item.type))
      }

      if (this.countriesFilter.length) {
        laureates = laureates.filter(item => item.countries.find(i => this.countriesFilter.includes(i.id)))
      }

      if (this.nationalitiesFilter.length) {
        laureates = laureates.filter(item => item.nationalities.find(i => this.nationalitiesFilter.includes(i.id)))
      }

      if (this.professionsFilter.length) {
        laureates = laureates.filter(item => item.professions.find(i => this.professionsFilter.includes(i.id)))
      }

      if (this.genderFilter.length) {
        laureates = laureates.filter(item => this.genderFilter.includes(item.gender))
      }

      // Date of Birth
      if (this.dateOfBirthFrom) {
        laureates = laureates.filter(item => {
          if (item.date_of_birth) {
            return parseInt(item.date_of_birth.substring(0, 4)) >= this.dateOfBirthFrom
          }
          return false
        })
      }
      if (this.dateOfBirthTo) {
        laureates = laureates.filter(item => {
          if (item.date_of_birth) {
            return parseInt(item.date_of_birth.substring(0, 4)) <= this.dateOfBirthTo
          }
          return false
        })
      }

      // Deceased
      if (this.ceasedToExistYes && !this.ceasedToExistNo) {
        laureates = laureates.filter(item => item.date_of_death !== null)
      }
      if (this.ceasedToExistNo && !this.ceasedToExistYes) {
        laureates = laureates.filter(item => item.date_of_death === null)
      }

      // Date of Death
      if (this.dateOfDeathFrom) {
        laureates = laureates.filter(item => {
          if (item.date_of_death) {
            return parseInt(item.date_of_death.substring(0, 4)) >= this.dateOfDeathFrom
          }
          return false
        })
      }
      if (this.dateOfDeathTo) {
        laureates = laureates.filter(item => {
          if (item.date_of_death) {
            return parseInt(item.date_of_death.substring(0, 4)) <= this.dateOfDeathTo
          }
          return false
        })
      }

      if (this.top100Filter.length) {
        laureates = laureates.filter(item => this.top100Filter.includes(item.top100_new))
      }

      return laureates
    },

    pagesQty () {
      return this.filteredLaureates.length % this.pageSize > 0 ? parseInt(this.filteredLaureates.length / this.pageSize) + 1 : parseInt(this.filteredLaureates.length / this.pageSize)
    },

    paginatedLaureates () {
      return this.filteredLaureates.slice((this.pageNumber - 1) * this.pageSize, this.pageNumber * this.pageSize)
    },

    years () {
      const years = []

      for (var i = this.moment().add(5, 'year').format('YYYY'); i >= 1900; i--) {
        years.push(i)
      }

      return years
    }
  },

  watch: {
    pageSize () {
      this.pageNumber = 1
    },

    search () {
      if (!this.search) {
        this.pageNumber = 1
      }
    }
  },

  methods: {
    callConfirmLaureateDeleteDialog (item) {
      this.laureateToDelete = item

      this.$refs.confirmLaureateDeleteDialog.open()
        .then((confirm) => {
          if (confirm) {
            this.deleteLaureate()
          }
        })
        .catch((error) => {
          console.log(error)
          this.showErrorMessage()
        })
    },

    deleteLaureate () {
      this.$http.delete('/laureates/' + this.laureateToDelete.id)
        .then(({ data }) => {
          this.laureates = this.laureates.filter(item => item.id !== this.laureateToDelete.id)

          this.showSuccessMessage('Laureate was deleted successfully!')
        })
        .catch(error => {
          console.log(error)
        })
    },

    getCountries () {
      return this.$http.get('/countries')
        .then(({ data }) => {
          this.countries = data.countries
        })
        .catch(error => {
          console.log(error)
        })
    },

    getLaureates () {
      return this.$http.get('/laureates?with_relations=1')
        .then(({ data }) => {
          this.laureates = data.laureates
        })
        .catch(error => {
          console.log(error)
        })
    },

    getProfessions () {
      return this.$http.get('/professions')
        .then(({ data }) => {
          this.professions = data.professions
        })
        .catch(error => {
          console.log(error)
        })
    },

    goToLaureate (id) {
      this.$router.push({ name: 'laureates.edit', params: { id: id } })
    },

    refreshFilters () {
      this.ceasedToExistYes = false
      this.ceasedToExistNo = false
      this.countriesFilter = []
      this.dateOfBirthFrom = null
      this.dateOfBirthTo = null
      this.dateOfDeathFrom = null
      this.dateOfDeathTo = null
      this.genderFilter = []
      this.nationalitiesFilter = []
      this.professionsFilter = []
      this.top100Filter = []
      this.typeFilter = []
    },

    sortBy (val) {
      this.sortByNameAsc = !this.sortByNameAsc

      this.laureates.sort((a, b) => {
        const nameA = a[val] ? a[val].toUpperCase() : ''
        const nameB = b[val] ? b[val].toUpperCase() : ''
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByDeceased () {
      this.sortByNameAsc = !this.sortByNameAsc

      this.laureates.sort((a, b) => {
        let nameA = 3
        let nameB = 3
        if (a.date_of_death && a.type === 'Person') {
          nameA = 1
        } else if (!a.date_of_death && a.type === 'Person') {
          nameA = 2
        }

        if (b.date_of_death && b.type === 'Person') {
          nameB = 1
        } else if (!b.date_of_death && b.type === 'Person') {
          nameB = 2
        }

        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    },

    sortByFullName () {
      this.sortByNameAsc = !this.sortByNameAsc

      this.laureates.sort((a, b) => {
        const firstNameA = a.first_name ? a.first_name.toUpperCase() : ''
        const lastNameA = a.last_name ? a.last_name.toUpperCase() : ''
        const firstNameB = b.first_name ? b.first_name.toUpperCase() : ''
        const lastNameB = b.last_name ? b.last_name.toUpperCase() : ''

        const nameA = firstNameA + ' ' + lastNameA
        const nameB = firstNameB + ' ' + lastNameB
        if (nameA === '' && nameB === '') {
          return 0
        }
        if (nameA === '') {
          return 1
        }
        if (nameB === '') {
          return -1
        }
        if (this.sortByNameAsc) {
          return nameA === nameB ? 0 : nameA > nameB ? 1 : -1
        }
        return nameA === nameB ? 0 : nameA < nameB ? 1 : -1
      })
    }
  }
}
</script>

<style scoped>
  .th-award-name {
    min-width: 200px;
  }

  .th-140 {
    min-width: 140px;
  }

  .th-date {
    min-width: 110px;
  }

  .th-clickable:hover {
    background-color: #eceff1;
    cursor: pointer;
  }

  .td-avatar {
    text-align: center;
  }

  .td-avatar img {
    max-height: 48px;
    max-width: 48px;
    vertical-align: middle;
  }

  .search >>> .v-input__slot {
    background: rgba(0,0,0,.06) !important;
  }

  .search-no-results >>> .v-input__slot {
    background: #ffcdd2 !important;
  }

  .tr-laureate:hover {
    cursor: pointer;
  }
</style>
